import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NavigationService } from '@app/core/service/navigation.service';
import { Router } from '@angular/router';
import { ConfirmationComponent } from '@app/shared/modals/confirmation';
import { UtilService, CONFIRMATION_MSGS } from '@app/core';
import { finalize } from 'rxjs/operators';
import { LOCAL_VAR } from '@app/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DealHelpComponent } from '@app/shared/modals/deal-help/deal-help.component';
import { DealsService } from '@app/core/service/deals.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { text } from '@angular/core/src/render3';

@Component({
  selector: 'app-custom-products',
  templateUrl: './custom-products.component.html',
  styleUrls: ['./custom-products.component.scss']
})
export class CustomProductsComponent implements OnInit {
  customCreateForm: FormGroup;
  modalRef: NgbModalRef;
  modalMode: string = 'create';
  editingItemId: string | null = null;
  @ViewChild('goto') nameInput: ElementRef;
  loggedInUserType: any = null;
  user: Authentication.User;
  productList: any;
  categories: any;
  fiterForm: FormGroup;
  isLoading = false;
  perPage = 10;
  sortDir = -1;
  currentPage = 1;
  sortBy = 'updateTime';
  pager = {
    perPage: 10,
    currentPage: 1,
    Totalrecords: 0,
    TotalPages: 0
  };
  PageList: any;
  timer: any;
  isProductLoading = false;
  productMaster: any[] = [];
  statusTypes = [
    { text: 'Enabled', value: false },
    { text: 'Disabled', value: true }
  ];
  productsCategory=[{name:'VSC', slug:'vsc'}, {name:'GAP', slug:'gap'}, {name:'Theft Protection', slug:'theft-protection'},{name:'Lease Excess Wear and Tear', slug:'lease-excess-wear-and-tear'}];

  currentStatus='';
  environmentUrl = environment.serverUrl;
  filterApplied: boolean=false;
  constructor(
    private modalService: NgbModal,
    private router: Router,
    public utilService: UtilService,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
     private toastrService: ToastrService,
    private dealsService: DealsService
  ) {
    this.user = this.authenticationService.credentials.user;
    // console.log(this.user)
    this.loggedInUserType = this.user.userRoleId.slug;
    localStorage.setItem(LOCAL_VAR.selectedAgency, null);
    this.getProductsarray();
    this.createForm();
    this.getListByFilter();
  }

  ngOnInit() {

  }



  createForm() {
    this.fiterForm = this.formBuilder.group({
      name: [''],
      category: [''],
      subcategory: [''],
      brand: [''],
      order: [''],
      submittedBy: [''],
      disable: [''],
      sortFieldFilter: ['createdAt'],
      sortByFilter: [-1],
      perPage: 10
    });

    this.customCreateForm = this.formBuilder.group({
      name: ['', Validators.required],
      brand: ['DOWC', Validators.required],
      category: ['servicecontract', Validators.required],
      subcategory: ['', Validators.required],
      order: [1, Validators.required],
      disable: [false]
    });

    // this.categories = this.productsCategory.map((prod) => {
    //   return { name: prod.name, slug: prod.slug, categorySlug: 'servicecontract' };
    // });


    // this.fiterForm.valueChanges.subscribe(values => {
    //   //this.pager.currentPage = 1;
    //   //this.getListByFilter();
    //   const self = this;
    //   clearInterval(self.timer);
    //   self.timer = setInterval(() => {
    //     clearInterval(self.timer);
    //     self.getListByFilter();
    //   }, 500);
    // });
  }

  onEnterSearch() {
    this.getListByFilter();
  }

  getProductName(slug: string){
    let product=this.productsCategory.find((prod)=>prod.slug==slug);
    return product?product.name:'';
  }

  clearFilters() {
    this.fiterForm.controls['name'].setValue('');
    this.fiterForm.controls['brand'].setValue('');
    this.fiterForm.controls['category'].setValue('');
    this.fiterForm.controls['subcategory'].setValue('');
    this.fiterForm.controls['order'].setValue('');
    this.fiterForm.controls['disable'].setValue('');
    this.fiterForm.controls['perPage'].setValue(10);
    // this.fiterForm.controls['sortFieldFilter'].setValue('createdAt');
    this.fiterForm.controls['sortByFilter'].setValue(-1);
    this.sortBy = 'createdAt';
    this.sortDir = -1;
    this.pager.currentPage = 1;
    this.pager.perPage = 10;
    this.getListByFilter();
  }

  getListByFilter() {
    const payload = this.getPayload();
    this.pager.perPage = payload.perPage;
    delete payload.perPage;
    this.getList(this.pager.currentPage, payload);
  }

  getList(page: number, payload: any) {
    payload.currentPage = page;
    payload.perPage = this.pager.perPage;
    this.isLoading = true;
    this.dealsService
      .getCustomProductsList(payload)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe((response: any) => {
        if (response.records) {
          this.productList = response.records;
          this.checkFilterApplied();
          this.renderPagination(
            response.page,
            response.total,
            response.totalPage
          );
        }
      },
      (error: any) => {
        console.log('Deal list error:', error);
        this.isLoading = false;
      });
  }

  checkFilterApplied() {
    const payload = this.getPayload();
    console.log('payload', payload);
    let applied = false;
    const keys = Object.keys(payload);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (
        key !== 'perPage' &&
        key !== 'sortFieldFilter' &&
        key !== 'sortByFilter' &&
        key !== 'currentPage'
      ) {
        applied = true;
        break;
      }
    }
    this.filterApplied = applied;
  }

   async sort(sortByVal: string) {
    if (this.sortBy === sortByVal) {
      this.sortDir = this.sortDir === 1 ? -1 : 1;
    } else {
      this.sortDir = 1;
    }
    /*  this.sortFieldFilter.setValue(sort);
    this.sortByFilter.setValue(sortDir); */
    this.fiterForm.value.sortFieldFilter = sortByVal;
    this.fiterForm.value.sortByFilter = this.sortDir;
    this.sortBy = sortByVal;
    this.getListByFilter();
  }

  goPage() {
    const goto = this.nameInput.nativeElement.value;
    this.setPage(goto);
    this.nameInput.nativeElement.value = '';
  }

  setPage(page: any) {
    if (
      0 < page &&
      page <= this.pager.TotalPages &&
      page != this.pager.currentPage
    ) {
      this.pager.currentPage = page;
      this.getListByFilter();
    }
  }

  renderPagination(page: number, total: number, totalPage: number) {
    this.pager.currentPage = page;
    this.pager.Totalrecords = total;
    this.pager.TotalPages = totalPage;
    this.PageList = this.utilService.getPageList(
      this.pager.TotalPages,
      this.pager.currentPage
    );
  }

  onBrandChange(selectedBrand: string): void {
    // console.log(selectedBrand);
    let products=['vsc','gap','theft-protection','lease-excess-wear-and-tear'];
    this.categories=[];
    let filtered: any = this.productMaster.find((element) => element.slug == selectedBrand);
    console.log(filtered)
    filtered.category.forEach((cat: any) => {
      if(cat.product && cat.product.length){
       cat.product.forEach((prod: any) => {
         if(products.includes(prod.slug)){
           this.categories.push({ name: prod.name, slug: prod.slug,categorySlug: cat.slug });
         }
        });
      }
    });
    if(this.modalMode==='create'){
      this.customCreateForm.controls['subcategory'].setValue('');
    }
    console.log(this.categories)
  }

  updateCategory(){
    let selectedSubcat=this.customCreateForm.get('subcategory').value;
    let selectedCategory=this.categories.find((cat:any)=>cat.slug==selectedSubcat);
    if(selectedCategory){
      this.customCreateForm.controls['category'].setValue(selectedCategory.categorySlug);
    }
  }

    getProductsarray() {
    // console.log('arayyyy');
    this.isProductLoading = true;
    this.dealsService
      .getProductsarray('master')
      .pipe(
        finalize(() => {
          this.isProductLoading = false;
        })
      )
      .subscribe((response: any) => {
        this.productMaster = response;
      });
  }

  openPop(modal: any, product: any) {
    if (product) {
      this.editingItemId = product._id;
      this.modalMode = 'Update';
      this.customCreateForm.reset({
        name: product.name,
        brand: product.brand,
        category: product.category,
        subcategory: product.subcategory,
        order: product.order,
        disable: product.disable?true:false
      });
      if(product.brand) this.onBrandChange(product.brand);
    } else {
      this.modalMode = 'create';
      this.editingItemId = null;
      this.customCreateForm.reset({
        name: '',
        brand: 'DOWC',
        category: 'servicecontract',
        subcategory: '',
        order: 1,
        disable: false
      });
      this.onBrandChange('DOWC');
    }
    const modalRef = this.modalService.open(modal, { backdrop: 'static' });
    modalRef.result.then((result) => {
      if (result === 'confirm') {
        // this.confirmChangeStatus(dealId);

      }
    })
  }

  openDelete(modal: any, productId: string){
    const modalRef = this.modalService.open(modal, { backdrop: 'static' });
    modalRef.result.then((result) => {
      if (result === 'confirm') {
        this.dealsService
      .removeCustomProduct(productId)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {

          this.toastrService.info('Custom product deleted successfully.');
          // this.modalRef.close();  
          // this.getListByFilter();
            setTimeout(() => {
              window.location.reload();
            }, 1000);

        },
        (error: any) => {
          console.log(
            'Confirmation modal error:',
            error.error.validation.errors
          );
          this.isLoading = false;
        }
      );
      }
    });
  }

  submitGroup() {
    if (this.customCreateForm.invalid) {
      for (const i in this.customCreateForm.controls) {
        console.log(i,this.customCreateForm.controls[i].value, this.customCreateForm.controls[i].invalid);
        this.customCreateForm.controls[i].markAsTouched();
      }
      return;
    }
    let payload=this.customCreateForm.value;
    payload.slug=this.utilService.convertSlug(payload.name);
    this.isLoading = true;
    this.dealsService
      .submitCustomProduct(this.customCreateForm.value,this.editingItemId)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {

          this.toastrService.info('Custom product submitted successfully.');
          // this.getListByFilter();
          // if (this.modalRef) {
          //   this.modalRef.close('success'); // or dismiss()
          //   this.modalRef = null;
          // }
           setTimeout(() => {
              window.location.reload();
            }, 1000);

        },
        (error: any) => {
          console.log(
            'Confirmation modal error:',
            error.error.validation.errors
          );
          this.isLoading = false;
        }
      );
  }

  getPayload() {
    let payload = JSON.parse(JSON.stringify(this.fiterForm.value));
    payload = this.utilService.removeEmpty(payload);
    return payload;
  }

   exportProducts() {
    const payload = this.getPayload();
    this.isLoading = true;
    this.dealsService
      .getCustomProductsExport({})
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe((response: any) => {
        if (response.data) {
          this.downloadFile(response.data);
        }
      });
  }

  downloadFile(data: string) {
    const aTag = document.createElement('a');
    document.body.appendChild(aTag);
    aTag.style.display = 'none';
    const url = this.environmentUrl.slice(0, -3) + '/' + data;
    aTag.href = url;
    aTag.setAttribute('target', '_blank');
    aTag.click();
    document.body.removeChild(aTag);
  }

  omit_special_char(event: any) {
    let k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k <= 122) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }

  omit_special_Mailchar(event: any) {
    let k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k <= 122) ||
      k === 46 ||
      k === 64 ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }


  async openHelpPopup() {
    const modalRef = await this.modalService.open(DealHelpComponent);
  }
}


